import { loadableReady } from '@loadable/component';
import { hydrateRoot } from 'react-dom/client';

import DebugRouter from '@core/utils/DebugRouter';
import PoweredBy from '@core/utils/poweredByLog';
import { debugHydrateRootHandler } from '@ui/HydrationDebugger';

import { init as initializeI18n } from './i18n';
import crossFrameHistory from './utils/crossFrameHistory';

import App from '.';

PoweredBy();

let FIRST_RUN = (window.FIRST_RUN = !('rehydrate' in window));

function readInitialProps() {
  const elem = document.getElementById('ssr-props');
  if (!elem?.textContent) {
    return {};
  }

  //give custom code a window to read ssr props.
  setTimeout(() => elem?.remove(), 1000);

  try {
    return JSON.parse(elem.textContent);
  } catch {
    return {};
  }
}

function hydrate(props, root, history) {
  if (!root) {
    return;
  }

  hydrateRoot(
    root,
    <DebugRouter history={history}>
      <App {...props} />
    </DebugRouter>,
    { onRecoverableError: debugHydrateRootHandler },
  );
}

function initialize() {
  if (!FIRST_RUN) {
    return;
  }

  const root = document.getElementById('ssr-main');
  const initialProps = readInitialProps();
  const history = crossFrameHistory({
    basename: initialProps.baseUrl,
    forceRefresh: !!initialProps.is404,
  });

  initializeI18n(initialProps.i18n?.language || 'en', initialProps.i18n?.translations || {});

  loadableReady(() => hydrate(initialProps, root, history));

  window.rehydrate = () => hydrate(initialProps, root, history);

  FIRST_RUN = false;
  window.FIRST_RUN = false;
}

initialize();
